import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { projectsApi, siteSettingsApi } from '../services/api'
import ProjectCard from '../components/ProjectCard'
import '../styles/Home.css'

function Home() {
  const [featuredProjects, setFeaturedProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [settingsLoaded, setSettingsLoaded] = useState(false)
  const [siteSettings, setSiteSettings] = useState({
    hero_title: null,
    hero_subtitle: null,
    hero_image_url: null,
    hero_title_size: '3.5rem',
    hero_subtitle_size: '1.5rem',
    instagram_url: null,
  })

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // Fetch the 3 most recent projects using limit parameter
        const response = await projectsApi.getAll({ limit: 3 })
        setFeaturedProjects(response.data)
      } catch (error) {
        console.error('Error fetching projects:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchProjects()
  }, [])

  // Load site settings
  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await siteSettingsApi.get()
        setSiteSettings(response.data)
      } catch (error) {
        console.error('Error loading site settings:', error)
      } finally {
        setSettingsLoaded(true)
      }
    }
    loadSettings()
  }, [])

  const heroStyle = siteSettings.hero_image_url
    ? { backgroundImage: `url(${siteSettings.hero_image_url})` }
    : {}

  return (
    <div className="home">
      <section className="hero" style={heroStyle}>
        {siteSettings.hero_image_url && <div className="hero-overlay"></div>}
        <div className="hero-content">
          {siteSettings.hero_title && (
            <h1
              className="hero-title"
              style={{ fontSize: siteSettings.hero_title_size || '3.5rem' }}
            >
              {siteSettings.hero_title}
            </h1>
          )}
          {siteSettings.hero_subtitle && (
            <p
              className="hero-subtitle"
              style={{ fontSize: siteSettings.hero_subtitle_size || '1.5rem' }}
            >
              {siteSettings.hero_subtitle}
            </p>
          )}
          <div className="hero-buttons">
            <Link to="/projects" className="btn btn-primary">
              View Projects
            </Link>
            {siteSettings.instagram_url && (
              <a
                href={siteSettings.instagram_url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary"
              >
                Follow on Instagram
              </a>
            )}
          </div>
        </div>
      </section>

      <section className="featured-projects">
        <h2>Latest Projects</h2>
        {loading ? (
          <div className="loading">Loading projects...</div>
        ) : featuredProjects.length > 0 ? (
          <>
            <div className="projects-grid">
              {featuredProjects.map((project) => (
                <ProjectCard key={project.id} project={project} />
              ))}
            </div>
            <div className="view-all">
              <Link to="/projects" className="btn btn-primary">
                View All Projects
              </Link>
            </div>
          </>
        ) : (
          <p className="no-projects">No projects yet. Check back soon!</p>
        )}
      </section>
    </div>
  )
}

export default Home
